/**
 * Tras añadir desde el quick-buy inline de tarjeta de colección, fuerza la apertura del drawer
 * del carrito (#mini-cart) para ver la línea recién añadida (el tema solo abre si cartType === drawer).
 */
(function () {
  var SELECTOR_FORM = 'form.product-item__quick-form--inline-atc';
  var ATTR = 'data-yodeyma-pending-mini-cart';

  document.addEventListener(
    'submit',
    function (ev) {
      var form = ev.target;
      if (form && form.matches && form.matches(SELECTOR_FORM)) {
        form.setAttribute(ATTR, 'true');
      }
    },
    true
  );

  document.documentElement.addEventListener('cart-notification:show', function (ev) {
    if (ev.detail && ev.detail.status === 'error') {
      document.querySelectorAll(SELECTOR_FORM + '[' + ATTR + ']').forEach(function (f) {
        f.removeAttribute(ATTR);
      });
    }
  });

  document.documentElement.addEventListener('cart:refresh', function () {
    var form = document.querySelector(SELECTOR_FORM + '[' + ATTR + ']');
    if (!form) return;
    form.removeAttribute(ATTR);
    var drawer = document.getElementById('mini-cart');
    if (!drawer || !('open' in drawer)) return;
    requestAnimationFrame(function () {
      drawer.open = true;
    });
  });
})();
